export const getFetchCurrentPatientsUrl = ({
  therapistId,
}: {
  therapistId: string;
}) => `therapists/${therapistId}/patients`;
